import { render, staticRenderFns } from "./workshift.vue?vue&type=template&id=7b397a0a&scoped=true&"
import script from "./workshift.vue?vue&type=script&lang=js&"
export * from "./workshift.vue?vue&type=script&lang=js&"
import style0 from "./workshift.vue?vue&type=style&index=0&id=7b397a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b397a0a",
  null
  
)

export default component.exports